/**
 * title {标题}
 * informationTypes {信息块}
 *      children {子块}
 *          blocks {内容块}
 *              name {内容标题}
 *              value {内容}
 *              type {类型：}TEXT {文本类型} FILE {文件类型} HTML {富文本} NODE {审批节点}
 *              className {内容块样式类}
 *              hideType {true || false}是否显示当前块
 */

export default {
  //车辆报废
  CAR_SCRAP: (data) => {
    let arr = data.tagsString
      ? data.tagsString
          .split(",")
          .filter((d) => {
            return d;
          })
          .join(",")
      : "";

    let obj = {
      title: "车辆资产处置",
      informationTypes: [
        {
          title: "报废车辆信息",
          blocks: [
            {
              name: "报废车辆",
              value: data.carPlateNumber,
              type: "TEXT",
            },
            {
              name: "车辆用途",
              value: data.useTypeDesc || "-",
              type: "TEXT",
            },
            {
              name: "车辆所有人",
              value: data.owner || "-",
              type: "TEXT",
            },
            {
              name: "车辆管理主体",
              value: data.managementSubject || "-",
              type: "TEXT",
            },
            {
              name: "车辆标签",
              value: arr || "-",
              type: "TEXT",
            },
            {
              name: "报废说明",
              value: data.scrapDesc || [],
              type: "TEXT",
            },
            {
              name: "相关附件（如车辆发票、商业险、事故责任认定书、事故定损单、事故保费证明、事故责任认定书、事故维修报价单、事故照片等。）",
              value: JSON.parse(data.scrapFiles) || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
    return obj;
  },
  //方案呈批
  PROGRAMME: (data) => {
    return {
      title: "方案审批",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads
                .map((item) => item.userName + "/" + item.jobCard)
                .join(),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders
                .map((item) => item.userName + "/" + item.jobCard)
                .join(),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: () => {
            if (data.levelTwo === "yxfa-8") {
              const programmeContent = JSON.parse(data.programmeContent);
              return [
                {
                  name: "事项一级分类",
                  value: data.levelOneName || "-",
                  type: "TEXT",
                },
                {
                  name: "事项二级分类",
                  value: data.levelTwoName || "-",
                  type: "TEXT",
                },
                {
                  name: "运营商名称",
                  value: programmeContent.customerName || "-",
                  type: "TEXT",
                },
                {
                  name: "城市",
                  value: programmeContent.city || "-",
                  type: "TEXT",
                },
                {
                  name: "原合作类型",
                  value: programmeContent.cooperateTypeName || "-",
                  type: "TEXT",
                },
                {
                  name: "合作开始时间",
                  value: programmeContent.cooperateStartDate || "-",
                  type: "TEXT",
                },
                {
                  name: "在租车辆数(台)",
                  value: programmeContent.rentCarNum || "-",
                  type: "TEXT",
                },
                {
                  name: "已提展车数(台)",
                  value: programmeContent.useCarNum || "-",
                  type: "TEXT",
                },
                {
                  name: "拟合作类型",
                  value: programmeContent.newCooperateTypeName || "-",
                  type: "TEXT",
                },
                {
                  name: "要求渠道保证金(元)",
                  value: programmeContent.depositAmount || "-", //原参needChannelDeposit
                  type: "TEXT",
                },
                {
                  name: "渠道保证金余额(元)",
                  value: programmeContent.channelDeposit || "-",
                  type: "TEXT",
                },
                {
                  name: "展车台数",
                  value: data.showCnt || "-",
                  type: "TEXT",
                },
                // {
                //   name: "渠道保证金差额(元)",
                //   value: (
                //     programmeContent.channelDeposit -
                //     programmeContent.needChannelDeposit
                //   ).toFixed(2),
                //   type: "TEXT",
                // },
                {
                  name: "相关附件",
                  value: data.files || [],
                  type: "FILE",
                },
              ];
            } else {
              return [
                {
                  name: "事项一级分类",
                  value: data.levelOneName || "-",
                  type: "TEXT",
                },
                {
                  name: "事项二级分类",
                  value: data.levelTwoName || "-",
                  type: "TEXT",
                },
                {
                  name: "方案名称",
                  value: data.programme || "-",
                  type: "TEXT",
                },
                {
                  name: "费用支出",
                  value: data.amount ? data.amount + "元" : "-",
                  type: "TEXT",
                  className: "textColorYellow",
                },
                {
                  name: "方案内容",
                  value: data.programmeContent || "-",
                  type: "HTML",
                },
                {
                  name: "相关附件",
                  value: data.files || [],
                  type: "FILE",
                },
              ];
            }
          },
        },
      ],
    };
  },
  //合同
  CONTRACT: (data) => {
    return {
      title: "OA合同审批",
      informationTypes: () => {
        let arr = [];
        console.log(data);
        if (data.levelTwo === "ywys-4") {
          const buyCarDetail = data.buyCarDetail
            ? JSON.parse(data.buyCarDetail)
            : {};
          arr = [
            {
              title: "经办信息",
              blocks: [
                {
                  name: "经办人",
                  value: data.operator
                    ? data.operator + "/" + data.operatorNo
                    : "-",
                  type: "TEXT",
                },
                {
                  name: "经办人所属部门",
                  value: data.operatorDept || "-",
                  type: "TEXT",
                },
                {
                  name: "部门负责人",
                  value: data.deptHeads
                    .map((item) => item.userName + "/" + item.jobCard)
                    .join(),
                  type: "TEXT",
                },
                {
                  name: "申请日期",
                  value: data.applyTime || "-",
                  type: "TEXT",
                },
                {
                  name: "归口部门负责人",
                  value: data.putUnders
                    .map((item) => item.userName + "/" + item.jobCard)
                    .join(),
                  type: "TEXT",
                },
                {
                  name: "申请单编号",
                  value: data.workOrder || "-",
                  type: "TEXT",
                },
              ],
            },
            {
              title: "基本信息",
              blocks: [
                {
                  name: "所属组织",
                  value: data.belongCompany || "-",
                  type: "TEXT",
                },
                {
                  name: "合同一级分类",
                  value: data.levelOneName || "-",
                  type: "TEXT",
                },
                {
                  name: "事项二级分类",
                  value: data.levelTwoName || "-",
                  type: "TEXT",
                },
                {
                  name: "合同类别说明",
                  value: data.levelDesc || "-",
                  type: "TEXT",
                },
                {
                  name: "是否本公司抬头",
                  value: data.myCompanyHead == "1" ? "是" : "否",
                  type: "TEXT",
                },
                {
                  name: "被借用单位领导",
                  value: data.borrowLeaders
                    ? data.borrowLeaders
                        .map((item) => item.userName + "/" + item.jobCard)
                        .join()
                    : "-",
                  type: "TEXT",
                  hideType: data.myCompanyHead == "1" ? false : true,
                },
                {
                  name: "我方合同签订单位",
                  value: data.signCompany || "-",
                  type: "TEXT",
                },
                {
                  name: "有无合同金额",
                  value: data.includeAmount == "1" ? "有" : "无",
                  type: "TEXT",
                },
                {
                  name: "合同总金额",
                  value: data.contractAmount ? data.contractAmount + "元" : "-",
                  type: "TEXT",
                  className: "textColorYellow",
                  hideType: data.includeAmount == "1" ? false : true,
                },
                {
                  name: "金额备注",
                  value: data.amountRemark || "-",
                  type: "TEXT",
                },
                {
                  name: "有无子合同",
                  value: data.hasSubContract == "1" ? "是" : "否",
                  type: "TEXT",
                },
                {
                  name: "子合同数",
                  value: data.subContractQuantity,
                  type: "TEXT",
                  hideType: data.hasSubContract == "1" ? false : true,
                },
                {
                  name: "子合同编号",
                  value: data.subContractNo,
                  type: "TEXT",
                  hideType: data.hasSubContract == "1" ? false : true,
                },
                {
                  name: "合同名称",
                  value: data.contractName,
                  type: "TEXT",
                },
                {
                  name: "客户名称",
                  value: buyCarDetail.customerName,
                  type: "TEXT",
                  hideType: data.levelTwo === "ywys-4" ? false : true,
                },
                {
                  name: "合同开始日期",
                  value: data.contractStartTime
                    ? data.contractStartTime.slice(0, 10)
                    : "-",
                  type: "TEXT",
                },
                {
                  name: "有无合同结束日期",
                  value: data.hasContractEndTime == "1" ? "有" : "无",
                  type: "TEXT",
                },
                {
                  name: "合同结束日期",
                  value: data.contractEndTime
                    ? data.contractEndTime.slice(0, 10)
                    : "-",
                  type: "TEXT",
                  hideType: data.hasContractEndTime == "1" ? false : true,
                },
                {
                  name: "合同编号",
                  value: data.contractNo,
                  type: "TEXT",
                },
                {
                  name: "合同概况及情况说明",
                  value: data.survey,
                  type: "HTML",
                },
                {
                  name: `购车清单(${data.buyCarDetail ? JSON.parse(data.buyCarDetail).cars.length : 0})`,
                  value: data.buyCarDetail
                    ? {
                        ...JSON.parse(data.buyCarDetail),
                        levelOne: data.levelOneName,
                        levelTwo: data.levelTwoName,
                      }
                    : { cars: [], levelOne: "", levelTwo: "" },
                  type: "CAR_PURCHASE_LIST", //定制化
                  hideType: !(
                    data.buyCarDetail &&
                    JSON.parse(data.buyCarDetail).cars &&
                    JSON.parse(data.buyCarDetail).cars.length > 0
                  ),
                },
                {
                  name: "结算方式及条件",
                  value: data.settlementMethod,
                  type: "HTML",
                },
                {
                  name: "双方权利义务",
                  value: data.obligations,
                  type: "HTML",
                },
                {
                  name: "违约责任约定",
                  value: data.liability,
                  type: "HTML",
                },
                {
                  name: "履行期限",
                  value: data.performQuantity,
                  type: "TEXT",
                  className: "blockTopLine",
                },
                {
                  name: "争议解决办法",
                  value: data.disputeResolution,
                  type: "HTML",
                },
                {
                  name: "对方单位",
                  value: data.cooperationCompany,
                  type: "TEXT",
                  className: "blockTopLine",
                },
                {
                  name: "对方单位地址",
                  value: data.cooperationCompanyAddress,
                  type: "TEXT",
                },
                {
                  name: "合同附件",
                  value: data.contractFiles || [],
                  type: "FILE",
                },
                {
                  name: "经审批的方案",
                  value: data.programmeFiles || [],
                  type: "FILE",
                },
              ],
            },
            {
              title: "销售信息",
              type: "aggregate",
              blocks: [
                {
                  name: "销售类型",
                  value: buyCarDetail.typeName || "-",
                  type: "TEXT",
                },
                {
                  name: "客户经理",
                  value:
                    buyCarDetail.managerUserName +
                    " / " +
                    buyCarDetail.managerJobCard,
                  type: "TEXT",
                },
                {
                  name: "购车数",
                  value: buyCarDetail.cars.length,
                  type: "TEXT",
                },
              ],
              children: buyCarDetail.cars.map((item) => {
                return {
                  title: `${item.carTypeName}`,
                  blocks: [
                    {
                      name: "销售价格(元/台)",
                      value: item.salePrice || "-",
                      type: "TEXT",
                    },
                    {
                      name: "VIN码",
                      value: item.deviceId || "-",
                      type: "TEXT",
                    },
                    {
                      name: "车牌号",
                      value: item.carPlateNumber || "-",
                      type: "TEXT",
                    },
                    {
                      name: "车辆定金(元/台)",
                      value: item.handsel || "-",
                      type: "TEXT",
                    },
                    {
                      name: "销售日期",
                      value: item.saleDate || "-",
                      type: "TEXT",
                    },
                  ],
                };
              }),
            },
            {
              title: "用印信息",
              blocks: [
                {
                  name: "印章类型",
                  value: data.sealType || "-",
                  type: "TEXT",
                },
                {
                  name: "用印份数",
                  value: data.printQuantity || "-",
                  type: "TEXT",
                },
                {
                  name: "印章管理员",
                  value: data.sealManagers.map(
                    (item) => item.userName + "/" + item.jobCard,
                  ),
                  type: "TEXT",
                },
                {
                  name: "申请日期",
                  value: data.applyTime || "-",
                  type: "TEXT",
                },
              ],
            },
          ];
        } else if (
          data.levelTwo === "ywys-rka" ||
          data.levelTwo === "ywys-ka"
        ) {
          arr = [
            {
              title: "经办信息",
              blocks: [
                {
                  name: "经办人",
                  value: data.operator
                    ? data.operator + "/" + data.operatorNo
                    : "-",
                  type: "TEXT",
                },
                {
                  name: "经办人所属部门",
                  value: data.operatorDept || "-",
                  type: "TEXT",
                },
                {
                  name: "部门负责人",
                  value: data.deptHeads
                    .map((item) => item.userName + "/" + item.jobCard)
                    .join(),
                  type: "TEXT",
                },
                {
                  name: "申请日期",
                  value: data.applyTime || "-",
                  type: "TEXT",
                },
                {
                  name: "归口部门负责人",
                  value: data.putUnders
                    .map((item) => item.userName + "/" + item.jobCard)
                    .join(),
                  type: "TEXT",
                },
                {
                  name: "申请单编号",
                  value: data.workOrder || "-",
                  type: "TEXT",
                },
              ],
            },
            {
              title: "基本信息",
              blocks: [
                {
                  name: "所属组织",
                  value: data.belongCompany || "-",
                  type: "TEXT",
                },
                {
                  name: "合同一级分类",
                  value: data.levelOneName || "-",
                  type: "TEXT",
                },
                {
                  name: "事项二级分类",
                  value: data.levelTwoName || "-",
                  type: "TEXT",
                },
                {
                  name: "合同类别说明",
                  value: data.levelDesc || "-",
                  type: "TEXT",
                },

                {
                  name: "我方合同签订单位",
                  value: data.signCompany || "-",
                  type: "TEXT",
                },

                {
                  name: "订单总金额",
                  value: data.contractAmount ? data.contractAmount + "元" : "-",
                  type: "TEXT",
                  className: "textColorYellow",
                  hideType: data.includeAmount == "1" ? false : true,
                },

                {
                  name: "订单情况说明",
                  value: data.survey,
                  type: "HTML",
                },

                {
                  name: "履行期限",
                  value: data.performQuantity,
                  type: "TEXT",
                  className: "blockTopLine",
                },
                {
                  name: "争议解决办法",
                  value: data.disputeResolution,
                  type: "HTML",
                },
                {
                  name: "对方单位",
                  value: data.cooperationCompany,
                  type: "TEXT",
                  className: "blockTopLine",
                },
                {
                  name: "对方单位地址",
                  value: data.cooperationCompanyAddress,
                  type: "TEXT",
                },
                {
                  name: "合同附件",
                  value: data.contractFiles || [],
                  type: "FILE",
                },
                {
                  name: "经审批的方案",
                  value: data.programmeFiles || [],
                  type: "FILE",
                },
              ],
            },
            {
              title: "用印信息",
              blocks: [
                {
                  name: "印章类型",
                  value: data.sealType || "-",
                  type: "TEXT",
                },
                {
                  name: "用印份数",
                  value: data.printQuantity || "-",
                  type: "TEXT",
                },
                {
                  name: "印章管理员",
                  value: data.sealManagers.map(
                    (item) => item.userName + "/" + item.jobCard,
                  ),
                  type: "TEXT",
                },
                {
                  name: "申请日期",
                  value: data.applyTime || "-",
                  type: "TEXT",
                },
              ],
            },
          ];
        } else {
          arr = [
            {
              title: "经办信息",
              blocks: [
                {
                  name: "经办人",
                  value: data.operator
                    ? data.operator + "/" + data.operatorNo
                    : "-",
                  type: "TEXT",
                },
                {
                  name: "经办人所属部门",
                  value: data.operatorDept || "-",
                  type: "TEXT",
                },
                {
                  name: "部门负责人",
                  value: data.deptHeads
                    .map((item) => item.userName + "/" + item.jobCard)
                    .join(),
                  type: "TEXT",
                },
                {
                  name: "申请日期",
                  value: data.applyTime || "-",
                  type: "TEXT",
                },
                {
                  name: "归口部门负责人",
                  value: data.putUnders
                    .map((item) => item.userName + "/" + item.jobCard)
                    .join(),
                  type: "TEXT",
                },
                {
                  name: "申请单编号",
                  value: data.workOrder || "-",
                  type: "TEXT",
                },
              ],
            },
            {
              title: "基本信息",
              blocks: [
                {
                  name: "所属组织",
                  value: data.belongCompany || "-",
                  type: "TEXT",
                },
                {
                  name: "合同一级分类",
                  value: data.levelOneName || "-",
                  type: "TEXT",
                },
                {
                  name: "事项二级分类",
                  value: data.levelTwoName || "-",
                  type: "TEXT",
                },
                {
                  name: "合同类别说明",
                  value: data.levelDesc || "-",
                  type: "TEXT",
                },
                {
                  name: "是否本公司抬头",
                  value: data.myCompanyHead == "1" ? "是" : "否",
                  type: "TEXT",
                },
                {
                  name: "被借用单位领导",
                  value: data.borrowLeaders
                    ? data.borrowLeaders
                        .map((item) => item.userName + "/" + item.jobCard)
                        .join()
                    : "-",
                  type: "TEXT",
                  hideType: data.myCompanyHead == "1" ? false : true,
                },
                {
                  name: "我方合同签订单位",
                  value: data.signCompany || "-",
                  type: "TEXT",
                },
                {
                  name: "合同名称",
                  value: data.contractName,
                  type: "TEXT",
                },
                {
                  name: "合同编号",
                  value: data.contractNo,
                  type: "TEXT",
                },
                {
                  name: "合同开始日期",
                  value: data.contractStartTime
                    ? data.contractStartTime.slice(0, 10)
                    : "-",
                  type: "TEXT",
                },
                {
                  name: "有无合同结束日期",
                  value: data.hasContractEndTime == "1" ? "有" : "无",
                  type: "TEXT",
                },
                {
                  name: "合同结束日期",
                  value: data.contractEndTime
                    ? data.contractEndTime.slice(0, 10)
                    : "-",
                  type: "TEXT",
                  hideType: data.hasContractEndTime == "1" ? false : true,
                },
                {
                  name: "有无合同金额",
                  value: data.includeAmount == "1" ? "有" : "无",
                  type: "TEXT",
                },
                {
                  name: "合同总金额",
                  value: data.contractAmount ? data.contractAmount + "元" : "-",
                  type: "TEXT",
                  className: "textColorYellow",
                  hideType: data.includeAmount == "1" ? false : true,
                },
                {
                  name: "金额备注",
                  value: data.amountRemark || "-",
                  type: "TEXT",
                },
                {
                  name: "二手车处置",
                  value: data.usedCarDisposal == "1" ? "是" : "否",
                  type: "TEXT",
                  hideType:
                    data.levelTwo == "ywys-8" && data.levelOne == "ywys"
                      ? false
                      : true,
                },
                {
                  name: "收到车款日期",
                  value: data.carPayDate ? data.carPayDate.slice(0, 10) : "-",
                  type: "TEXT",
                  hideType:
                    data.levelTwo == "ywys-8" &&
                    data.levelOne == "ywys" &&
                    data.usedCarDisposal == "1"
                      ? false
                      : true,
                },
                {
                  name: "有无子合同",
                  value: data.hasSubContract == "1" ? "是" : "否",
                  type: "TEXT",
                },
                {
                  name: "子合同数",
                  value: data.subContractQuantity,
                  type: "TEXT",
                  hideType: data.hasSubContract == "1" ? false : true,
                },
                {
                  name: "子合同编号",
                  value: data.subContractNo,
                  type: "TEXT",
                  hideType: data.hasSubContract == "1" ? false : true,
                },
                {
                  name: "合同概况及情况说明",
                  value: data.survey,
                  type: "HTML",
                },
                {
                  name: `购车清单(${data.buyCarDetail ? JSON.parse(data.buyCarDetail).cars.length : 0})`,
                  value: data.buyCarDetail
                    ? {
                        ...JSON.parse(data.buyCarDetail),
                        levelOne: data.levelOne,
                        levelTwo: data.levelTwo,
                      }
                    : {
                        cars: [],
                        levelOne: data.levelOne,
                        levelTwo: data.levelTwo,
                      },
                  type: "CAR_PURCHASE_LIST", //定制化
                  hideType: !(
                    data.buyCarDetail &&
                    JSON.parse(data.buyCarDetail).cars &&
                    JSON.parse(data.buyCarDetail).cars.length > 0
                  ),
                },
                {
                  name: "结算方式及条件",
                  value: data.settlementMethod,
                  type: "HTML",
                },
                {
                  name: "双方权利义务",
                  value: data.obligations,
                  type: "HTML",
                },
                {
                  name: "违约责任约定",
                  value: data.liability,
                  type: "HTML",
                },
                {
                  name: "履行期限",
                  value: data.performQuantity,
                  type: "TEXT",
                  className: "blockTopLine",
                },
                {
                  name: "争议解决办法",
                  value: data.disputeResolution,
                  type: "HTML",
                },
                {
                  name: "对方单位",
                  value: data.cooperationCompany,
                  type: "TEXT",
                  className: "blockTopLine",
                },
                {
                  name: "对方单位地址",
                  value: data.cooperationCompanyAddress,
                  type: "TEXT",
                },
                {
                  name: "合同附件",
                  value: data.contractFiles || [],
                  type: "FILE",
                },
                {
                  name: "经审批的方案",
                  value: data.programmeFiles || [],
                  type: "FILE",
                },
              ],
            },
            {
              title: "用印信息",
              blocks: [
                {
                  name: "印章类型",
                  value: data.sealType || "-",
                  type: "TEXT",
                },
                {
                  name: "用印份数",
                  value: data.printQuantity || "-",
                  type: "TEXT",
                },
                {
                  name: "印章管理员",
                  value: data.sealManagers.map(
                    (item) => item.userName + "/" + item.jobCard,
                  ),
                  type: "TEXT",
                },
                {
                  name: "申请日期",
                  value: data.applyTime || "-",
                  type: "TEXT",
                },
              ],
            },
          ];
        }
        return arr;
      },
    };
  },
  //付款
  PAY: (data) => {
    let obj = {
      title: "付款审批",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "预算管理员",
              value: data.budgetManagers
                ? data.budgetManagers.map(
                    (item) => item.userName + "/" + item.jobCard,
                  )
                : "",
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
          ],
        },
        {
          title: "付款业务信息",
          blocks: [
            {
              name: "事项一级分类",
              value: data.levelOneName || "-",
              type: "TEXT",
            },
            {
              name: "事项二级分类",
              value: data.levelTwoName || "-",
              type: "TEXT",
            },
            {
              name: "客户名称",
              value: data.customerName
                ? data.customerName + "/" + data.phoneNumber
                : "-",
              type: "TEXT",
              hideType: data.levelTwoName === "渠道保证金退款" ? false : true,
            },
            {
              name: "渠道保证金账户余额（元）",
              value: data.channelAmount ? data.channelAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
              hideType: data.levelTwoName === "渠道保证金退款" ? false : true,
            },
            {
              name: "付款方式",
              value: data.payMethod || "-",
              type: "TEXT",
            },
            {
              name: "付款总金额",
              value: data.totalAmount ? data.totalAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "收款单位/人",
              value: data.payee || "-",
              type: "TEXT",
            },
            {
              name: "收款账户",
              value: data.bankAccount || "-",
              type: "TEXT",
            },
            {
              name: "银行名称",
              value: data.bankName || "-",
              type: "TEXT",
            },
            {
              name: "开户行名称",
              value: data.bankAddress || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "付款明细",
          children: data.payDetails.map((item) => {
            return {
              title: item.name,
              blocks: [
                {
                  name: "发票张数",
                  value: item.quantity,
                  type: "TEXT",
                },
                {
                  name: "金额",
                  value: item.amount ? item.amount + "元" : "-",
                  type: "TEXT",
                },
                {
                  name: "备注",
                  value: item.remark || "-",
                  type: "TEXT",
                },
              ],
            };
          }),
        },
        {
          title: "前置审批及所附单据",
          blocks: [
            {
              name: "方案",
              value: data.programmeFiles || [],
              type: "FILE",
            },
            {
              name: "方案审批流编号",
              value: data.programmeWorkOrder || "-",
              type: "TEXT",
            },
            {
              name: "合同/协议",
              value: data.contractFiles || [],
              type: "FILE",
            },
            {
              name: "合同审批流编号",
              value: data.contractWorkOrder || [],
              type: "TEXT",
            },
            {
              name: "其他相关附件",
              value: data.relaFiles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
    return obj;
  },
  //出差付款
  TRAVEL_PAY: (data) => {
    return {
      title: "付款_差旅费",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads
                ? data.deptHeads.map(
                    (item) => item.userName + "/" + item.jobCard,
                  )
                : "-",
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "预算管理员",
              value: data.budgetManagers
                ? data.budgetManagers.map(
                    (item) => item.userName + "/" + item.jobCard,
                  )
                : "",
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "付款业务信息",
          blocks: [
            {
              name: "事项一级分类",
              value: data.levelOneName || "-",
              type: "TEXT",
            },
            {
              name: "事项二级分类",
              value: data.levelTwoName || "-",
              type: "TEXT",
            },
            {
              name: "出差开始时间",
              value: data.travelStartTime || "-",
              type: "TEXT",
            },
            {
              name: "出差结束时间",
              value: data.travelEndTime || "-",
              type: "TEXT",
            },
            {
              name: "出差地点",
              value: data.travelAddress || "-",
              type: "TEXT",
            },
            {
              name: "出差人员",
              value: data.travelPerson || "-",
              type: "TEXT",
            },
            {
              name: "付款方式",
              value: data.payMethod || "-",
              type: "TEXT",
            },
            {
              name: "付款总金额",
              value: data.totalAmount ? data.totalAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "收款单位/人",
              value: data.payee || "-",
              type: "TEXT",
            },
            {
              name: "收款账户",
              value: data.bankAccount || "-",
              type: "TEXT",
            },
            {
              name: "银行名称",
              value: data.bankName || "-",
              type: "TEXT",
            },
            {
              name: "开户行名称",
              value: data.bankAddress || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "付款明细",
          children: data.payDetails.map((item) => {
            return {
              title: item.name,
              blocks: [
                {
                  name: "发票张数",
                  value: item.quantity,
                  type: "TEXT",
                },
                {
                  name: "金额",
                  value: item.amount ? item.amount + "元" : "-",
                  type: "TEXT",
                },
                {
                  name: "备注",
                  value: item.remark || "-",
                  type: "TEXT",
                },
              ],
            };
          }),
        },
        {
          title: "前置审批及所附单据",
          blocks: [
            {
              name: "事前申请编号",
              value: data.travelWorkOrder
                ? data.travelWorkOrder.indexOf(",") > -1
                  ? data.travelWorkOrder.replace(/,/g, "\n")
                  : data.travelWorkOrder
                : "-",
              type: "TEXT",
            },
            {
              name: "其他相关附件",
              value: data.relaFiles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  //招待付款
  ENTERTAIN_PAY: (data) => {
    return {
      title: "付款_业务招待费",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "预算管理员",
              value: data.budgetManagers
                ? data.budgetManagers.map(
                    (item) => item.userName + "/" + item.jobCard,
                  )
                : "",
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "付款业务信息",
          blocks: [
            {
              name: "事项一级分类",
              value: data.levelOneName || "-",
              type: "TEXT",
            },
            {
              name: "事项二级分类",
              value: data.levelTwoName || "-",
              type: "TEXT",
            },
            {
              name: "招待事项",
              value: data.entertainMatter || "-",
              type: "TEXT",
            },
            {
              name: "招待日期",
              value: data.entertainDate || "-",
              type: "TEXT",
            },
            {
              name: "付款方式",
              value: data.payMethod || "-",
              type: "TEXT",
            },
            {
              name: "付款总金额",
              value: data.totalAmount ? data.totalAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "收款单位/人",
              value: data.payee || "-",
              type: "TEXT",
            },
            {
              name: "收款账户",
              value: data.bankAccount || "-",
              type: "TEXT",
            },
            {
              name: "银行名称",
              value: data.bankName || "-",
              type: "TEXT",
            },
            {
              name: "开户行名称",
              value: data.bankAddress || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "付款明细",
          children: data.payDetails.map((item) => {
            return {
              title: item.name,
              blocks: [
                {
                  name: "发票张数",
                  value: item.quantity,
                  type: "TEXT",
                },
                {
                  name: "金额",
                  value: item.amount ? item.amount + "元" : "-",
                  type: "TEXT",
                },
                {
                  name: "备注",
                  value: item.remark || "-",
                  type: "TEXT",
                },
              ],
            };
          }),
        },
        {
          title: "前置审批及所附单据",
          blocks: [
            {
              name: "事前申请编号",
              value: data.entertainWorkOrder
                ? data.entertainWorkOrder.indexOf(",") > -1
                  ? data.entertainWorkOrder.replace(/,/g, "\n")
                  : data.entertainWorkOrder
                : "-",
              type: "TEXT",
            },
            {
              name: "其他相关附件",
              value: data.relaFiles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  //印章管理
  SEAL: (data) => {
    return {
      title: "用印申请",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "用印分类",
              value: data.useSealType || "-",
              type: "TEXT",
            },
            {
              name: "印章保管处",
              value: data.sealHome || "-",
              type: "TEXT",
            },
            {
              name: "文件类型",
              value: data.fileType || "-",
              type: "TEXT",
            },
            {
              name: "印章类别",
              value: data.sealType ? data.sealType.join("，") : "-",
              type: "TEXT",
            },
            {
              name: "用印主题",
              value: data.useSealTitle || "-",
              type: "TEXT",
            },
            {
              name: "公司印章管理员",
              value: data.sealManagers.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "财务负责人",
              value: data.financeManagers.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "法务",
              value: data.legalStaffs.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "用印主体信息",
              value: data.useSealCompany || "-",
              type: "TEXT",
            },
            {
              name: "份数",
              value: data.quantity ? data.quantity + "份" : "-",
              type: "TEXT",
            },
            {
              name: "盖章内容",
              value: data.content || "-",
              type: "HTML",
            },
            {
              name: "申请附件",
              value: data.files || [],
              type: "FILE",
            },
            {
              name: "备注",
              value: data.remark || "-",
              type: "TEXT",
            },
          ],
        },
      ],
    };
  },
  //招待费申请
  ENTERTAIN_APPLY: (data) => {
    return {
      title: "招待费事前申请",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "直接主管",
              value: data.supervisors.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "招待对象",
              value: data.entertainPerson || "-",
              type: "TEXT",
            },
            {
              name: "招待费（预估）",
              value: data.entertainAmount ? data.entertainAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "参加人数",
              value: data.quantity ? data.quantity + "人" : "-",
              type: "TEXT",
            },
            {
              name: "招待类型",
              value: data.entertainType || "-",
              type: "TEXT",
            },
            {
              name: "同去人员",
              value: data.accompanyPerson || "-",
              type: "TEXT",
            },
            {
              name: "招待地点",
              value: data.entertainAddress || "-",
              type: "TEXT",
            },
            {
              name: "招待日期",
              value: data.entertainTime || "-",
              type: "TEXT",
            },
            {
              name: "招待事由",
              value: data.entertainMattr || "-",
              type: "TEXT",
            },
            {
              name: "申请附件",
              value: data.files || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  //出差申请
  TRAVEL_APPLY: (data) => {
    return {
      title: "出差申请",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "直接主管",
              value: data.supervisors.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "人事行政备案人",
              value: data.officeStaffs.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "差旅信息",
          blocks: [
            {
              name: "费用归属公司",
              value: data.belongCompany || "-",
              type: "TEXT",
            },
            {
              name: "差旅类型",
              value: data.travelType || "-",
              type: "TEXT",
            },
            {
              name: "是否探亲",
              value: ["否", "是"][data.visit],
              type: "TEXT",
            },
            {
              name: "人力资源负责人",
              value: data.officeManagers.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "开始日期",
              value: data.travelStartTime || "-",
              type: "TEXT",
            },
            {
              name: "结束日期",
              value: data.travelEndTime || "-",
              type: "TEXT",
            },
            {
              name: "出差天数",
              value: data.travelDays + "天",
              type: "TEXT",
            },
            {
              name: "总预估费用",
              value: data.totalAmount + "元",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "出差人员",
              value: data.travelPerson || "-",
              type: "TEXT",
            },
            // {
            //     name: '责任人',
            //     value: data.dutyPerson ? data.dutyPerson + '/' + data.dutyPersonNo : '-',
            //     type: 'TEXT'
            // },
            {
              name: "出差事由",
              value: data.travelReason || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "交通信息",
          children: data.traffics.map((item) => {
            return {
              title: `${item.startAddress} 至 ${item.endAddress}`,
              blocks: [
                {
                  name: "交通工具",
                  value: item.vehicle || "-",
                  type: "TEXT",
                },
                {
                  name: "仓位(座位)类型",
                  value: item.seatType || "-",
                  type: "TEXT",
                },
                {
                  name: "预估费用",
                  value: item.amount + "元",
                  type: "TEXT",
                },
                {
                  name: "备注",
                  value: item.remark || "-",
                  type: "TEXT",
                },
              ],
            };
          }),
        },
        {
          title: "住宿信息",
          children: data.stays.map((item) => {
            return {
              title: item.city,
              blocks: [
                {
                  name: "天数",
                  value: item.days + "天",
                  type: "TEXT",
                },
                {
                  name: "预估费用",
                  value: item.amount + "元",
                  type: "TEXT",
                },
              ],
            };
          }),
        },
        {
          title: "其他信息",
          children: data.others.map((item) => {
            return {
              title: item.feeType,
              blocks: [
                {
                  name: "其他预估费用",
                  value: item.amount + "元",
                  type: "TEXT",
                },
                {
                  name: "备注",
                  value: item.remark || "-",
                  type: "TEXT",
                },
              ],
            };
          }),
        },
      ],
    };
  },
  //法律专项
  SPECIAL: (data) => {
    return {
      title: "法律专项方案审批",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "事项一级分类",
              value: data.levelOneName || "-",
              type: "TEXT",
            },
            {
              name: "事项二级分类",
              value: data.levelTwoName || "-",
              type: "TEXT",
            },
            {
              name: "专项性质",
              value: data.specialNature || "-",
              type: "TEXT",
            },
            {
              name: "专项方案名称",
              value: data.specialScheme || "-",
              type: "TEXT",
            },
            {
              name: "标的金额",
              value: data.amount ? data.amount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "诉讼费用",
              value: data.litigationAmount ? data.litigationAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "法律服务费",
              value: data.legalAmount ? data.legalAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "其他金额",
              value: data.otherAmount ? data.otherAmount + "元" : "-",
              type: "TEXT",
              className: "textColorYellow",
            },
            {
              name: "我方专项单位",
              value: data.specialCompany || "-",
              type: "TEXT",
            },
            {
              name: "对方单位全称",
              value: data.cooperationCompany || "-",
              type: "TEXT",
            },
            {
              name: "法定代表人",
              value: data.legalPerson || "-",
              type: "TEXT",
            },
            {
              name: "对方注册地址",
              value: data.companyAddress || "-",
              type: "TEXT",
            },
            {
              name: "统一信用代码",
              value: data.unifiedCreditCode || "-",
              type: "TEXT",
            },
            {
              name: "联系人",
              value: data.linkName || "-",
              type: "TEXT",
            },
            {
              name: "联系方式",
              value: data.linkTel || "-",
              type: "TEXT",
            },
            {
              name: "项目基本内容",
              value: data.baseContent || "-",
              type: "HTML",
            },
            {
              name: "诉讼或非诉讼处理方案",
              value: data.litigationProgramme || "-",
              type: "HTML",
            },
            {
              name: "法律服务方案",
              value: data.legalServicesProgramme || "-",
              type: "HTML",
            },
            {
              name: "律师是否入库",
              value: ["未入库", "已在库"][data.employ],
              type: "TEXT",
              className: "blockTopLine",
            },
            {
              name: "选聘路径",
              value: data.employSource || "-",
              type: "TEXT",
            },
            {
              name: "其他理由",
              value: data.otherReason || "-",
              type: "TEXT",
            },
            {
              name: "入库文件上传",
              value: data.inFiles || [],
              type: "FILE",
            },
            {
              name: "专项方案附件",
              value: data.programmeFiles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  // 控车白名单申请
  CAR_CONTROL_WHITE: (data) => {
    return {
      title: "控车白名单申请",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "事项分类",
              value: "控车白名单申请",
              type: "TEXT",
            },
            {
              name: "主题",
              value: data.matterTitle || "-",
              type: "TEXT",
            },
            {
              name: "事项备注",
              value: data.memo || "-",
              type: "HTML",
            },
            {
              name: "相关附件",
              value: data.relaFIles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  // 收车日期变更
  TIME_CHANGE: (data) => {
    return {
      title: "收车日期变更",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "事项分类",
              value: "收车日期变更",
              type: "TEXT",
            },
            {
              name: "主题",
              value: data.matterTitle || "-",
              type: "TEXT",
            },
            {
              name: "事项备注",
              value: data.memo || "-",
              type: "HTML",
            },
            {
              name: "相关附件",
              value: data.relaFIles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  // 已收账单退回审批
  RECEIVED_BACK: (data) => {
    return {
      title: "已收账单退回审批",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "事项分类",
              value: "已收账单退回审批",
              type: "TEXT",
            },
            {
              name: "主题",
              value: data.matterTitle || "-",
              type: "TEXT",
            },
            {
              name: "事项备注",
              value: data.memo || "-",
              type: "HTML",
            },
            {
              name: "相关附件",
              value: data.relaFIles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },
  // 通用数据订正申请
  DATA_REVISION: (data) => {
    return {
      title: "通用数据订正申请",
      informationTypes: [
        {
          title: "经办信息",
          blocks: [
            {
              name: "经办人",
              value: data.operator
                ? data.operator + "/" + data.operatorNo
                : "-",
              type: "TEXT",
            },
            {
              name: "经办人所属部门",
              value: data.operatorDept || "-",
              type: "TEXT",
            },
            {
              name: "部门负责人",
              value: data.deptHeads.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请日期",
              value: data.applyTime || "-",
              type: "TEXT",
            },
            {
              name: "归口部门负责人",
              value: data.putUnders.map(
                (item) => item.userName + "/" + item.jobCard,
              ),
              type: "TEXT",
            },
            {
              name: "申请单编号",
              value: data.workOrder || "-",
              type: "TEXT",
            },
          ],
        },
        {
          title: "基本信息",
          blocks: [
            {
              name: "事项分类",
              value: "通用数据订正申请",
              type: "TEXT",
            },
            {
              name: "主题",
              value: data.matterTitle || "-",
              type: "TEXT",
            },
            {
              name: "事项备注",
              value: data.memo || "-",
              type: "HTML",
            },
            {
              name: "相关附件",
              value: data.relaFIles || [],
              type: "FILE",
            },
          ],
        },
      ],
    };
  },

  // 审批节点
  examine(data) {
    return {
      title: "审批信息",
      blocks: [
        {
          name: "-",
          value: data || "-",
          type: "NODE",
        },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/processReview/template.js